import React, {Component} from 'react';
import ConsentFormsUtil from "./utils/ConsentFormsUtil";
import StringUtil from "../../utils/StringUtil";
import {TextInput, Wizard} from "../../components";
import RemotingService from "../../services/remoting-service/RemotingService";
import ValidationUtil from "../../components/form/validator/ValidationUtil";
import SignatureInput from "../../components/signature-input/SignatureInput";
import ClinicLogo from "../../layout/ClinicLogo";
import FormField from "../../components/form/FormField";
import PatientUtil from "../../utils/PatientUtil";
import DateUtil from "../../utils/DateUtil";
import TeleconsultationFormTextEnum from "./teleconsultation/enum/TeleconsultationFormTextEnum";
import FormLanguages from "./enum/FormLanguages";
import SignatureDisplay from '../../components/signature-input/SignatureDisplay';
import {YesNoRadioInput} from "./public/YesNoRadioInput";
import {isMinor} from '../patient/Patient';

class TeleconsultationConsentForm extends Component {

    constructor(props) {
        super(props)

        this.state = {
            patientDate: new Date()
        }

        this.formFields = [];
    }

    componentDidMount() {
        RemotingService.getRemoteCall('api/appointment/first-provider/UAE/' + this.props.patient.id, {},
            (firstProvider) => {
                if (firstProvider) {
                    this.setState({providerName: firstProvider.name, providerSignature: firstProvider.signature});
                }
            });
    }

    onSubmit = () => {
        if (!ValidationUtil.checkWithNotification(this.formFields)) {
            return;
        }

        if (this.props.form !== null && this.props.form !== undefined) {
            this.props.close();
        } else {
            const patient = this.props.patient;
            const patientFullName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
            const patientMrn = StringUtil.mrn(patient.mrn);
            const patientDOB = patient.birthday;

            const {
                participateInTeleconsultation, patientDate, guardianName, guardianRelationship,
                patientSignature, witnessName, witnessSignature, providerName, providerSignature
            } = this.state;

            RemotingService.postRemoteCall(`api/patient/${this.props.patient.id}/teleconsultation-consent-form`,
                {
                    participateInTeleconsultation,
                    patientDate,
                    guardianName,
                    guardianRelationship,
                    patientSignature,
                    witnessName,
                    witnessSignature,
                    patientFullName,
                    patientMrn,
                    patientDOB,
                    providerName,
                    providerSignature
                },
                (result) => {
                    this.props.afterSave(result);
                    this.props.close();
                });
        }
    }

    onSaveWitnessSignature = (signature) => {
        this.setState({witnessSignature: signature})
    }

    onSavePatientSignature = (signature) => {
        this.setState({patientSignature: signature})
    }

    getLocalizedText(key) {
        const selectedLanguage = this.props.selectedLanguage || FormLanguages.ENGLISH.name;
        const textEnum = TeleconsultationFormTextEnum;
        return textEnum[key] ? textEnum[key][selectedLanguage.name] : '';
    }

    render() {
        if (!this.props.show)
            return null;

        let {patient, form} = this.props;
        let readOnly = form !== null && form !== undefined;
        let mrnNo = StringUtil.mrn(patient.mrn);
        let patientName = PatientUtil.getPatientName(patient.firstName, patient.middleName, patient.lastName);
        this.formFields = [];

        const selectedLanguage = this.props.selectedLanguage || FormLanguages.ENGLISH.name;
        const enumLabel = selectedLanguage === FormLanguages.ARABIC ? "nameInArabic" : "name";
        const isPatientMinor = isMinor(patient.birthday, 'KUWAIT');

        return (
            <Wizard
                show={this.props.show}
                close={this.props.close}
                title={this.getLocalizedText('Teleconsultation_Consent_Form_Header')}
                onSubmit={this.onSubmit}
                isReadOnly={readOnly}
            >
                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{maxWidth: '950px'}}>
                        <div style={{
                            marginTop: '15px', marginBottom: '15px', width: '100%', display: 'flex',
                            flexFlow: 'row', justifyContent: 'space-between', alignItems: 'center'
                        }}>
                            <ClinicLogo/>
                            <div>
                                <h2>{this.getLocalizedText('Teleconsultation_Consent_Form_Title')}</h2>
                            </div>
                        </div>

                        <hr style={{
                            borderTop: "2px solid #000000",
                            marginTop: "-10px",
                            boxShadow: "0px 2px 2px #797979"
                        }}/>

                        <div style={{border: "1px solid #000000"}}>
                            <div style={{margin: "15px 15px"}}>
                                <h5>{this.getLocalizedText('Patient_Information')}</h5>
                                <div className={"row"} style={{marginTop: "10px", marginLeft: "0px"}}>
                                    <div className="col-md-5">
                                        <b>{this.getLocalizedText('Name')}</b> {patientName}
                                    </div>
                                    <div className="col-md-4">
                                        <b>{this.getLocalizedText('MRN')}</b> {mrnNo}
                                    </div>
                                    <div className="col-md-3">
                                        <b>{this.getLocalizedText('DOB')}</b> {DateUtil.formatDate(patient.birthday)}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "15px 15px"}}>
                                {this.getLocalizedText('Treatment_Consideration')}
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{maxWidth: '950px'}}>
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "10px 15px"}}>
                                <p><b>{this.getLocalizedText('Electronic_Systems')}</b><br/>
                                    {this.getLocalizedText('Electronic_Systems_Description')}
                                </p>

                                <p><b>{this.getLocalizedText('Nature_Of_Teleconsultation')}</b><br/>
                                    {this.getLocalizedText('Nature_Of_Teleconsultation_Description')}
                                    <ul className={"list-unstyled"}>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                                {this.getLocalizedText('Nature_Of_Teleconsultation_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                                {this.getLocalizedText('Nature_Of_Teleconsultation_Point2')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>

                                <p><b>{this.getLocalizedText('Medical_Information_And_Records')}</b>
                                    {this.getLocalizedText('Medical_Information_Description')}
                                </p>

                                <p><b>{this.getLocalizedText('Confidentiality')}</b>
                                    {this.getLocalizedText('Confidentiality_Description')}
                                </p>

                                <p><b>{this.getLocalizedText('Rights')}</b>
                                    {this.getLocalizedText('Rights_Description')}
                                </p>

                                <p><b>{this.getLocalizedText('Expected_Benefits')}</b><br/>
                                    <ul className={"list-unstyled"}>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                                {this.getLocalizedText('Expected_Benefits_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                                {this.getLocalizedText('Expected_Benefits_Point2')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                                <p><b>{this.getLocalizedText('Possible_Risks')}</b><br/>
                                    {this.getLocalizedText('Possible_Risks_Description')}
                                    <ul className={"list-unstyled"}>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                                {this.getLocalizedText('Possible_Risks_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                                {this.getLocalizedText('Possible_Risks_Point2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                                {this.getLocalizedText('Possible_Risks_Point3')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                                {this.getLocalizedText('Possible_Risks_Point4')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{maxWidth: '950px'}}>
                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "10px 15px"}}>
                                <p><b>{this.getLocalizedText('Questions_And_Concerns')}</b><br/>
                                    {this.getLocalizedText('Questions_And_Concerns_Section1_Description')}
                                </p>

                                <p>
                                    <ul className={"list-unstyled"}>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section1_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section1_Point2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section1_Point3')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>

                                <p>
                                    {this.getLocalizedText('Questions_And_Concerns_Section2_Description')}
                                    <ul className={"list-unstyled"}>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point3')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point4')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>e.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section2_Point5')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{maxWidth: '950px'}}>

                        <div style={{border: "1px solid #000000", margin: "10px 0px"}}>
                            <div style={{margin: "10px 15px"}}>
                                <p>
                                    {this.getLocalizedText('Questions_And_Concerns_Section3_Description')}
                                    <ul className={"list-unstyled"}>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>a.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point1')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>b.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point2')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>c.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point3')}
                                            </p>
                                        </li>
                                        <li>
                                            <p><span className={"mr-2 d-inline font-weight-bold"}>d.</span>
                                                {this.getLocalizedText('Questions_And_Concerns_Section3_Point4')}
                                            </p>
                                        </li>
                                    </ul>
                                </p>
                            </div>
                        </div>

                        <div style={{border: "1px solid #000000", margin: "10px 0px", display: "flex"}}>
                            <div style={{flex: 1, margin: "10px 15px"}}>
                                <p><b>{this.getLocalizedText('Final_Consent_Statement')}</b></p>
                            </div>
                            <div style={{borderLeft: "1px solid #000000", padding: "10px"}}>
                                <p className="display-flex">
                                    <FormField ref={formField => this.formFields.push(formField)} required
                                               validateOn={readOnly ? true : this.state.participateInTeleconsultation}>
                                        <YesNoRadioInput id="participateInTeleconsultation" readOnly={readOnly}
                                                         enumLabel={enumLabel}
                                                         value={readOnly ? form.participateInTeleconsultation : this.state.participateInTeleconsultation}
                                                         onValueChange={(value) => this.setState({participateInTeleconsultation: value})}/>
                                    </FormField>
                                </p>
                            </div>
                        </div>

                        <div className={"container"}>
                            <div className={"row"} style={{marginTop: "10px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Date')}
                                </div>

                                <div className="col-md-3">
                                    {readOnly && form.patientDate ?
                                        ConsentFormsUtil.formatSignatureDate(form.patientDate)
                                        :
                                        ConsentFormsUtil.formatSignatureDate(this.state.patientDate)
                                    }
                                </div>
                            </div>

                            <div className="row" style={{marginTop: "15px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Patient_Name')}
                                </div>
                                <div className="col-md-3">
                                    {patientName}
                                </div>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Provider_Name')}
                                </div>
                                <div className="col-md-3">
                                    <TextInput value={this.state.providerName}
                                               disabled={true} style={{textAlign: "center"}}/>
                                </div>
                            </div>

                            <div className={"row"} style={{marginTop: "10px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Print_Name')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        disabled={!isPatientMinor}
                                        required requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={readOnly ? form.guardianName : this.state.guardianName}>
                                        <TextInput value={readOnly ? form.guardianName : this.state.guardianName}
                                            disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                            onChange={(val) => this.setState({ guardianName: val })} />
                                    </FormField>
                                </div>
                            </div>
                            <div className={"row"} style={{marginTop: "10px"}}>
                                <div className="col-md-3 dim14-form-label">
                                    {this.getLocalizedText('Relationship_To_Patient')}
                                </div>
                                <div className="col-md-3 dim14-base-input">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                        disabled={!isPatientMinor}
                                        required requiredMessage={this.getLocalizedText('Field_Required')}
                                        validateOn={readOnly ? form.guardianName : this.state.guardianName}>
                                        <TextInput
                                            value={readOnly ? form.guardianRelationship : this.state.guardianRelationship}
                                            disabled={readOnly} alphabeticOnly style={{ textAlign: "center" }}
                                            onChange={(val) => this.setState({ guardianRelationship: val })} />
                                    </FormField>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Patient_Signature')}
                                </div>
                                <div className="col-md-6 dim14-form-label">
                                    {this.getLocalizedText('Provider_Signature')}
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-6">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                               disabled={readOnly}
                                               required requiredMessage={this.getLocalizedText('Signature_Required')}
                                               validateOn={this.state.patientSignature}>
                                        <SignatureInput
                                            signature={readOnly ? form.patientSignature : this.state.patientSignature}
                                            onSave={this.onSavePatientSignature} readOnly={readOnly}/>
                                    </FormField>
                                </div>
                                <div className="col-md-6">
                                    <FormField ref={formField => this.formFields.push(formField)}
                                               validateOn={this.state.providerSignature}
                                               required requiredMessage={this.getLocalizedText('Signature_Required')}>
                                        <SignatureDisplay signature={this.state.providerSignature}/>
                                    </FormField>
                                </div>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>

                <Wizard.Page
                    onNext={(event) => ValidationUtil.stopEventPropagationIfValidationFails(event, this.formFields)}
                    onPrevious={() => this.formFields = []}>
                    <div style={{width: '1000px'}}>
                        <div className={"row"} style={{margin: "10px 15px"}}>
                            <div className="col-md-12">
                                <p className="font-weight-bold">
                                    <u>{this.getLocalizedText('Official_Use_Only')}</u></p>
                                <p className="font-weight-bold">
                                    {this.getLocalizedText('Witness_Statement_Header')}</p>
                                <p><i>{this.getLocalizedText('Witness_Statement')}</i></p>
                            </div>
                        </div>

                        <div className="row" style={{margin: "10px 15px"}}>
                            <div className="col-md-6 dim14-form-label">
                                {this.getLocalizedText('Witness_Name')}
                            </div>
                            <div className="col-md-6 dim14-base-input">
                                <TextInput value={readOnly ? form.witnessName : this.state.witnessName}
                                           disabled={readOnly} alphabeticOnly style={{textAlign: "center"}}
                                           onChange={(val) => this.setState({witnessName: val})}/>
                            </div>
                            <div className="col-md-6 dim14-form-label">
                                {this.getLocalizedText('Witness_Signature')}
                            </div>
                            <div className="col-md-6">
                                <SignatureInput
                                    signature={readOnly ? form.witnessSignature : this.state.witnessSignature}
                                    onSave={this.onSaveWitnessSignature} readOnly={readOnly}/>
                            </div>
                        </div>
                    </div>
                </Wizard.Page>
            </Wizard>
        );
    }
}

export default TeleconsultationConsentForm;
